// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './axios'
import saxios from './axios/sacrifice.js'
import gaxios from './axios/parkUrl.js'
import store from './store'
import ElementUI from 'element-ui'
import ECharts from 'vue-echarts'
import BaiduMap from 'vue-baidu-map'
import {
  serverUrl,
  sacrificeUrl,
  staticUrl,
  parkUrl,
  zfUrl
} from '../static/js/config.js'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/css/function.css'
import '../static/css/reset.css'
import '../static/css/custom.css'

Vue.config.productionTip = false
//点击跳转页面自动定位在顶部
router.afterEach((to,from,next)=>{
  window.scrollTo(0,0)
})
store.commit('initservel', {
  serverUrl,
  staticUrl,
  sacrificeUrl,
  parkUrl,
})
axios.defaults.baseURL = location.href.indexOf("localhost") > 0 ? "/api" : store.state.config.serverUrl
saxios.defaults.baseURL = store.state.config.sacrificeUrl
gaxios.defaults.baseURL = store.state.config.parkUrl

Vue.prototype.$http = axios
Vue.prototype.$axios = saxios
Vue.prototype.$xaxios = gaxios
Vue.use(ElementUI)
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'YguYirrUSF8ftHoy2Bb34MZOMmg6KPCb'
})
Vue.component('v-chart', ECharts)
// router.beforeEach((to, from, next) => {
//   console.log(to)
//   let menus = JSON.parse(localStorage.getItem('menus'));
//   console.log('menus', menus)
//   router.$addRoutes(menus)
//   console.log(router)
//   next();
// })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js